import { usePageLayout, useStore } from '@libs/common-next';
import { Tooltip } from '@petsmart-ui/sparky';

import './StoreTooltip.scss';

type StoreTooltipProps = {
    isFormField?: boolean;
};

export default function StoreTooltip({ isFormField }: Readonly<StoreTooltipProps>) {
    const { contactUsFormStore } = usePageLayout();
    const { selectedStore } = useStore();

    const store = isFormField ? contactUsFormStore : selectedStore?.data;

    return (
        <div className="store-tooltip__address">
            {store ? (
                <Tooltip
                    hideIcon
                    enableHover
                    buttonVariant="link"
                    buttonText={store.Name}
                    data-testid="tooltip-address"
                >
                    {store.StreetLine1}
                    <br />
                    {store.City}, {store.StateProvinceAbbreviation} {store.ZipPostalCode}
                </Tooltip>
            ) : (
                <div>Please select a store</div>
            )}
        </div>
    );
}
